<div class="container" style="padding: 5px !important">
  <div class="row">
    <div class="col-12">
      <h3 class="text-center">{{"accounts.new_code.deposit_locations" | translate}}</h3>
    </div>
    <div class="col-12 mt-2">
      <div class="d-flex justify-content-center align-items-center">
        <button class="btn btn-primary" (click)="linkToCreateCode()">
          <i class="fas fa-plus-circle"></i> {{"accounts.new_code.deposit_without_card" | translate}}
        </button>
        <button class="btn btn-primary ml-3" (click)="openInfoModal(modal_locations)">
          <i class="fas fa-map-marker-alt"></i> {{"accounts.new_code.find_location" | translate}}
        </button>
      </div>
    </div>
    <div class="col-12 mt-4">
      <!--Lista de códigos creados-->
        <h3 class="text-center">{{"accounts.new_code.barcode_show_title" | translate}}</h3>
        <div class="form-column">
          <div class="row">
            <div class="col-12" style="padding: 0px !important;">
              <div class="table-responsive">
                <div class="overflow-auto">
                  <table class="table table-sm mt-1" *ngIf="barcodes.length > 0" style="border: 2px solid black; border-radius: 5px;
">
                    <thead>
                    <tr>
                      <th scope="col" class="text-center">{{ "accounts.new_code.description" | translate }}</th>
                      <th scope="col" class="text-center">{{ "accounts.new_code.target" | translate}}</th>
                      <th scope="col" class="text-center">{{ "accounts.new_code.amount" | translate }}</th>
                      <th scope="col" class="text-center">{{ "accounts.new_code.expiration_date" | translate }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngFor="let barcode of barcodes">
                      <tr *ngIf="barcode.status === iBarcodeStatus.NEW || barcode.status === iBarcodeStatus.PENDING"  (click)="openBarcode(content)" class="tr-action-call">
                        <ng-template #content let-modal>
                          <div class="modal-header">
                            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body text-center">
                            <div class="modal-title text-center">
                              <h4 [innerHTML]="'accounts.greenDot-barcode.use-only' | translate: { retailer: barcode.retailer.name }"></h4>
                              <h3>{{"accounts.greenDot-barcode.how-much" | translate}}</h3>
                              <h1><strong>{{barcode.amount | currency:'$':'symbol':'1.2':'en'}}</strong></h1>
                            </div>
                          </div>

                          <div class="text-center">

                            <app-bar-codes-custom [barcodeValue]="barcode.id"></app-bar-codes-custom>

                            <h4 class="text-success">{{"accounts.greenDot-barcode.deposit" | translate}}</h4>
                            <img src="assets/logos/greenDot_logo.png" class="text-center" width="120" alt="">
                          </div>

                          <div class="alert alert-info text-center mt-3">
                            <p style="margin-bottom: 0" [innerHTML]="'accounts.greenDot-barcode.instructions' | translate: { amount: barcode.amount | currency:'$':'symbol':'1.2':'en' }"></p>
                          </div>

                          <div class="ml-4">
                            <p class="text-left" [innerHTML]="'accounts.greenDot-barcode.retailer' | translate:{ retailer: barcode.retailer.name }" ></p>
                            <p class="text-left" [innerHTML]="'accounts.greenDot-barcode.expiration' | translate:{ date: barcode.expirationDate | date:'MM-dd-yyyy HH:mm:ss ': 'utc' }" ></p>
                            <p>{{ "accounts.new_code.find_closer" | translate: {retailer: barcode.retailer.name} }}<a href='https://www.google.com.mx/maps/search/{{barcode.retailer.name}}/' target="_blank" class="d-inline"><b>{{"accounts.new_code.click_here" | translate}}</b></a></p>
                          </div>
                        </ng-template>
                        <td>
                          <p class="m-0 font-weight-bold bigger-font text-center">{{ barcode.retailer.name }}</p>
                          <p class="text-center" [ngClass]="getBarcodeClass(barcode.status) ? 'm-0 text-success' : 'm-0 text-danger'">{{ barcode.status | filterBarcodeStatus }}</p>
                        </td>
                        <td>
                          <p class="text-center" *ngIf="barcode.loadType === 'THIRD_PARTY_ACCOUNT'">{{ "accounts.new_code.third_party" | translate}}</p>
                          <p class="text-center" *ngIf="barcode.loadType === 'OWNER_ACCOUNT'">{{ "accounts.new_code.owner_account" | translate}}</p>
                        </td>
                        <td class="amount-label" [ngClass]="{ 'positive-amount': barcode.amount }">
                          <p class="text-center">{{ barcode.amount | currency: '$':'symbol':'1.2':'en' }}</p>
                        </td>
                        <td>
                          <p class="text-center">{{ barcode.expirationDate | date: 'MM-dd-yyyy': 'utc' }}</p>
                        </td>
                      </tr>
                    </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" *ngIf="barcodes.length==0">
            <div class="alert alert-info text-center mt-2" role="alert">
              <i class="fas fa-info-circle fa-lg"></i>
              <p class="m-0 ">{{ "accounts.new_code.barcode_not_found" | translate }}</p>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>

<!-- Green Dot Deposit Locations -->
<ng-template #modal_greenDot_nc let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ "accounts.new_code.directed_new_website" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p class="text-justify">{{ "accounts.new_code.privacy_policy" | translate }}</p>
  </div>
  <div class="modal-footer">
    <div class="btn-group">
      <button type="button" class="btn btn-outline-dark" (click)="modal.close()">{{ "accounts.new_code.close" | translate }}</button>
      <a class="btn btn-primary" href="https://secure.attheregister.com/locations" target="_blank">{{ "accounts.new_code.ok" | translate }}</a>
    </div>
  </div>
</ng-template>


<ng-template #modal_locations let-modal>

  <div class="wrap-modal">
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <section>
      <span>
        {{ "accounts.new_code.info_modal_1" | translate }}.
        <strong>{{productName}}</strong>,
        {{ "accounts.new_code.info_modal_2" | translate }}.
      </span>

      <button type="button" class="btn btn-primary btn-lg btn-block rounded" (click)="modal.dismiss(); openModal(modal_greenDot_nc)">
        <span>
          <i class="fas fa-map-marker-alt"></i>
          &nbsp;
          {{ "accounts.new_code.text_btn_find" | translate }}.
        </span>
      </button>

      <article>
        <p>
          {{ "accounts.new_code.step_one_1" | translate }} <strong>{{productName}}</strong> {{ "accounts.new_code.step_one_2" | translate }}.
        </p>
        <p>
          <!-- Paso 2: Entrega el efectivo al cajero y él pasará la tarjeta. Puede aplicarse una tarifa por depósito. -->
          {{ "accounts.new_code.step_two" | translate }}
        </p>
        <p>
          <!-- Paso 3: El cajero te proporcionará un recibo como comprobante del depósito. El dinero depositado en la tarjeta estará generalmente disponible en un plazo de 10 minutos. -->
          {{ "accounts.new_code.step_three" | translate }}
        </p>
      </article>
    </section>
  </div>

</ng-template>
